import React from 'react';
import './TransactionHeaderCard.css';
import { withTranslation } from 'react-i18next';
import NPCard from '../../../comp/card/NPCard';
import NPLabeledValue from '../../../comp/NPLabeledValue';
import AffareTrattoreAPI from '../../../api/AffareTrattoreAPI';

/**
 * Displays the key data of the transaction
 */
function TransactionHeaderCard({ transaction }) {

    if (!transaction) return (<></>)

    const imageURL = new AffareTrattoreAPI().getAdImageProxiedUrl(transaction.adImageURL);

    const currency = transaction.currency ? transaction.currency : "EUR";

    return (
        <NPCard>
            <div className="tx-header-card">
                <div className='image'>
                    <img src={imageURL} />
                </div>
                <div className="tx-header-box">
                    <NPLabeledValue size="large" label="Oggetto della compravendita" value={transaction.adTitle} />
                </div>
                {/* <div className="tx-header-box">
                    <NPLabeledValue size="large" label="label.amount" type="currency" currency={currency} value={transaction.price} notAvailableLabel="Non disponibile" />
                </div>
                <div className="tx-header-box">
                    <NPLabeledValue size="large" label="Costi di spedizione" type="currency" currency={currency} value={transaction.shippingCost} notAvailableLabel="Non disponibile" />
                </div> */}

            </div>
        </NPCard>
    )
}

export default withTranslation()(TransactionHeaderCard);